import { useEffect } from 'react';
import { useTracker } from '../tracking/useTracker';
import { Step } from 'signup-constants/Step';
import { emailClientFromDomain, mailOptionsMapper } from './emailUtils';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoToMailButton = ({
  email
}) => {
  const stepKey = Step.CodeVerification;
  const emailClient = emailClientFromDomain(email);
  const Tracker = useTracker();
  const onLoad = () => {
    if (emailClient) {
      Tracker.signupInteraction(`verification-shown-go-to-${emailClient}`);
    }
  };

  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  useEffect(onLoad, []);
  const handleGoToEmail = () => {
    if (emailClient) {
      Tracker.click({
        message: 'click go to mail',
        linkLocation: `verify email button - ${emailClient}`
      });
    }
  };
  if (!email || !emailClient) {
    return null;
  }
  const {
    link,
    logo
  } = mailOptionsMapper[emailClient];
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    marginBlockStart: "600",
    children: /*#__PURE__*/_jsxs(Button, {
      external: true,
      hideExternalLinkIcon: true,
      href: link,
      use: "secondary",
      onClick: handleGoToEmail,
      children: [/*#__PURE__*/_jsx(Image, {
        alt: "logo",
        responsive: false,
        src: logo
      }), I18n.text(`views.${stepKey}.openEmailButton`)]
    })
  });
};
export default GoToMailButton;